/**
 * @file  src\components\Inventory\CreateInventory\InventoryLandNiceToHaves.js
 * @brief  This file is responsible for nice to haves in land inventory creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import { getNiceToHaves } from "../../../services/commonServices";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FenceIcon from "../../../images/fence-icon.svg";
import PastrolViewIcon from "../../../images/pastoral-view-img.png";
import {
  INVENTORY_LAND,
  MAX_SELECTION_COUNT,
  NICE_2_HAVES_LOT_LAND_CATEGORIES,
  propertyTab,
} from "../../../constants/common";
import { convertToNumber } from "../../../helpers/validations";

const InventoryLandNiceToHaves = (props) => {
  const { nice2Have, handleContinueButtonState, handleFormValues } = props;
  const [niceToHavesList, setNiceToHavesList] = useState([]);
  const [activeTab, setActiveTab] = useState(propertyTab);
  const [order, setOrder] = useState(0);
  const [selectedItemId, setSelectedItemId] = useState();
  const [itemArray, setItemarray] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [countByCategory, setCountByCategory] = useState({});

  useEffect(() => {
    getNiceToHaves(INVENTORY_LAND)
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const list = _.get(response, "result", null);
          setNiceToHavesList(list);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
    if (nice2Have) {
      setItemarray(nice2Have);
      setOrder(nice2Have.length);
    }
  }, []);
  /**
   * To handle ordering of selected nice to haves
   */
  const handleItemOrdering = () => {
    const arrayOfCurrentSelectedItem = itemArray.filter(
      (item) =>
        item.id === convertToNumber(selectedItemId) && item.tab === activeTab
    );
    const selectedItemOrder = arrayOfCurrentSelectedItem
      ? _.get(arrayOfCurrentSelectedItem[0], "order", "")
      : "";

    if (arrayOfCurrentSelectedItem.length === 0) {
      const updatedArray = [
        ...itemArray,
        {
          id: convertToNumber(selectedItemId),
          order: convertToNumber(order),
          tab: activeTab,
        },
      ];
      if (selectedItemId) setItemarray(updatedArray);
    } else {
      const newArray = itemArray.filter(
        (item) => item.order !== convertToNumber(selectedItemOrder)
      );

      const reOrderedArray = newArray.map((ro) => {
        const currentOrder = convertToNumber(_.get(ro, "order", ""));
        if (currentOrder > selectedItemOrder) {
          return {
            id: convertToNumber(ro.id),
            order: convertToNumber(currentOrder) - 1,
            tab: ro.tab,
          };
        } else {
          return {
            id: convertToNumber(ro.id),
            order: convertToNumber(currentOrder),
            tab: ro.tab,
          };
        }
      });

      if (selectedItemId) setItemarray(reOrderedArray);
    }
  };
  useEffect(() => {
    handleItemOrdering();
  }, [selectedItemId, order]);

  useEffect(() => {
    setTotalCount(itemArray.length);
    handleFormValues({ nice2Have: itemArray });
    if (itemArray.length > 0) {
      handleContinueButtonState();
    } else {
      const isDisable = true;
      handleContinueButtonState(isDisable);
    }
    const countByCategory = itemArray.reduce((acc, item) => {
      acc[item.tab] = (acc[item.tab] || 0) + 1;
      return acc;
    }, {});
    setCountByCategory(countByCategory);
  }, [itemArray]);

  const loadNiceToHaveList = (list, tab) => {
    const itemList =
      list &&
      list.map((pl) => {
        const name = _.get(pl, "Text");
        const id = _.get(pl, "Id");
        const imgPath = _.get(pl, "Img");
        const Icon = _.get(pl, "Icon");

        let selectedItems = itemArray.filter((item) => item.tab === tab);

        const match = selectedItems.find((item) => item.id === id && item.tab === tab);

        const order = _.get(match, "order", null);

        return (
          <div className="col-sm-3" id={id} key={id} onClick={handleItemClick}>
            <div
              className={
                order
                  ? "property-display position-relative mb-4 selected-property"
                  : "property-display position-relative mb-4"
              }
            >
              <div className="property-img-wrap">
                {order ? (
                  <div className="fence-icn-count">
                    <span>{order}</span>
                  </div>
                ) : (
                  <div className="fence-icn-wrap">

                    <img src={
                      Icon
                        ? (() => {
                          try {
                            return require("..//../../images/" + Icon);
                          } catch (e) {
                            return FenceIcon;
                          }
                        })()
                        : FenceIcon
                    } />

                  </div>
                )}

                <img src={
                  imgPath
                    ? (() => {
                      try {
                        return require("..//../../images/" + imgPath);
                      } catch (e) {
                        return PastrolViewIcon;
                      }
                    })()
                    : PastrolViewIcon
                } />
              </div>
              <div className="property-img-info">{name}</div>
            </div>
          </div>
        );
      });
    return itemList;
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  /**
   * To handle nice to have item click
   * @param {*} e
   */
  const handleItemClick = (e) => {
    const itemId = e.currentTarget.id;
    const isAlreadyExistedItem = itemArray.filter(
      (item) =>
        convertToNumber(item.id) === convertToNumber(itemId) &&
        item.tab === activeTab
    );

    if (
      totalCount + 1 <= MAX_SELECTION_COUNT ||
      isAlreadyExistedItem.length !== 0
    ) {
      setOrder(itemArray.length + 1);
      setSelectedItemId(itemId);
    } else {
      alert("Selection Up to 10 items only");
    }
  };

  return (
    <div className="center-content-sec mw-100">
      <div className="wantad-nicetohaves-wrap navlink-blue">
        <Tabs
          id="controlled-tab-example1"
          className="mb-5 flex-column flex-sm-row nav-justified"
          onSelect={(tab) => handleTabClick(tab)}
        >
          {NICE_2_HAVES_LOT_LAND_CATEGORIES.map((category) => (
            <Tab
              className="me-0 sm-me-4"
              eventKey={category.category}
              title={countByCategory[category.category] > 0 ? `${category.title} (${countByCategory[category.category]})` : category.title}
            >
              <div className="row"> {loadNiceToHaveList(niceToHavesList[category.category], category.category)}</div>
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
};
export default InventoryLandNiceToHaves;
